import { Alert } from "@mui/material";
import { radii } from "../../../theme/designTokens";

export default function EmptyStateAlert({ message, severity = "warning" }) {
  return (
    <Alert severity={severity} sx={{ borderRadius: radii.md }}>
      {message}
    </Alert>
  );
}
